__turbopack_context__.v({
  "className": "instrument_serif_3dadd8f7-module__lbVa5W__className",
});
